import React from 'react';
import { TFunction } from 'i18next';
import { CarouselItem } from '../../Carousel/Carousel';
import EntryStateText from '../../EntryStateText/EntryStateText';
import EntryPicksWrapper from '../../EntryPicksWrapper/EntryPicksWrapper';
import TabMenu from '../../TabMenu/TabMenu';
import { TabMenuItemResult } from '../../TabMenuItem/TabMenuItem';
import PrizePool from '../../PrizePool/PrizePool';
import { PayoutTableItemProps } from '../../PayoutTableItem/PayoutTableItem';
import { GetPredictorStatsResponse, PredictorStat } from '../../../interfaces/predictors';
import { AbandonedRace, isAbandonedRace, PickedHorse } from '../../../store/entry/entryActions';
import { numberUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/numberUtilities';

export const getMySelectionScreen = ({
  settled,
  resultsTabs,
  t,
}: {
  settled: boolean;
  resultsTabs: TabMenuItemResult[];
  t: TFunction;
}): CarouselItem => {
  const uniqueId = numberUtilities.getUniqueId();
  return {
    node: (
      <>
        <TabMenu items={resultsTabs} />
        {settled && <EntryStateText />}
        <div className={'selection-screen__entry-wrapper'}>
          <div className={'controls-info'}>
            <div className={'controls-info__side'}>{t('my-selections')}</div>
            <div className={'controls-info__side controls-info__side--right'}>{t('result')}</div>
          </div>
          <EntryPicksWrapper uniqueId={uniqueId} state={'in-play'} />
        </div>
        <PrizePool />
      </>
    ),
    id: 'my-selections',
  };
};
const formatPlayersStat = (stat: PredictorStat): string => {
  if (stat.position <= 3) {
    return stat.entryCount.toString();
  }

  const percentage = stat.entryPercentage * 100;
  if (percentage > 0 && percentage < 1) {
    return '<1%';
  }

  return `${Math.round(percentage)}%`;
};

export const getPayoutTableItems = ({
  predictorStats,
  amountCorrect,
  currencyCode,
}: {
  predictorStats?: GetPredictorStatsResponse;
  amountCorrect: number;
  currencyCode: string;
}): PayoutTableItemProps[] => {
  if (!predictorStats) return [];
  return predictorStats.predictorStats
    .map((stat) => {
      return {
        total: predictorStats.predictorNumPicks,
        correct: stat.correctPicks,
        players: formatPlayersStat(stat),
        focused: stat.correctPicks === amountCorrect,
        prize: stat.prizes.find((prize) => prize.prizeCurrencyCode === currencyCode),
      };
    })
    .filter((item) => item.correct > 1);
};

export const getResultTabs = ({ pickedHorses }: { pickedHorses: Array<PickedHorse | AbandonedRace> }) => {
  return pickedHorses
    .filter((pick) => pick.active)
    .map<TabMenuItemResult>((horse, i) => {
      if (isAbandonedRace(horse)) {
        return {
          tabText: horse?.eventNumber ?? i + 1,
          type: 'result',
          position: '-',
          selectionResult: 'A',
        };
      }

      return {
        tabText: horse?.eventNumber ?? i + 1,
        type: 'result',
        position: horse?.place || undefined,
        selectionResult: horse?.selectionResult,
      };
    });
};
